import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from "../models/auth/_models/config";
import { environment } from "src/environments/environment";
import { Oauth } from '../models/auth/_models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class OauthService {

  get config(): Oauth {
    const data = localStorage.getItem(`${environment.USERDATA_KEY}-${environment.appVersion}Ouath`);
    if (data && data !== '') {
      return JSON.parse(atob(data));
    }
    return new Oauth();
  }

  constructor(private http: HttpClient) { }

  clean() {    
    localStorage.removeItem(`${environment.USERDATA_KEY}-${environment.appVersion}`);
    localStorage.removeItem('licensemessageerror');
  }

  async getAppConfig(): Promise<void> {
    try {
      const config = await this.http.get<Oauth>('assets/config/oauth.json').toPromise();
      if (config) {
        localStorage.setItem(`${environment.USERDATA_KEY}-${environment.appVersion}Ouath`, btoa(JSON.stringify(config)));
      }
    } catch (error) {
      // console.error(`ConfigService: ${error}`);
    }
  }


}
